export const SquareIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M14.9931 2.5H5.00687C3.6215 2.5 2.5 3.6215 2.5 5.00687V14.9931C2.5 16.3785 3.6215 17.5 5.00687 17.5H14.9931C16.3785 17.5 17.5 16.3785 17.5 14.9931V5.00687C17.5 3.6215 16.3785 2.5 14.9931 2.5ZM14.7705 13.9871C14.7705 14.4241 14.4159 14.7787 13.9788 14.7787H6.02117C5.58411 14.7787 5.22952 14.4241 5.22952 13.9871V6.02117C5.22952 5.58411 5.58411 5.22952 6.02117 5.22952H13.9871C14.4241 5.22952 14.7787 5.58411 14.7787 6.02117V13.9871H14.7705Z"
        fill="#1A1A1A"
      />
      <path
        d="M8.41448 12.0311C8.15885 12.0311 7.96094 11.825 7.96094 11.5776V8.40276C7.96094 8.14713 8.16709 7.94922 8.41448 7.94922H11.5976C11.8449 7.94922 12.0511 8.15538 12.0511 8.40276V11.5776C12.0511 11.8332 11.8449 12.0311 11.5976 12.0311H8.41448Z"
        fill="#1A1A1A"
      />
    </svg>
  );
};
